export enum UserRewardSourceEnum {
  STORE_REVIEW = 'STORE_REVIEW',
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  TIKTOK = 'TIKTOK',
  GOVOIR_STORE_REVIEW = 'GOVOIR_STORE_REVIEW',
  GOVOIR_INSTAGRAM = 'GOVOIR_INSTAGRAM',
  GOVOIR_FACEBOOK = 'GOVOIR_FACEBOOK',
  GOVOIR_TIKTOK = 'GOVOIR_TIKTOK'
}
